import {
  Page,
  Text,
  Document,
  StyleSheet,
  Image,
  Font,
  View,
  Link,
} from "@react-pdf/renderer";
import { optionsTime } from "src/constants/options-time";
import { Brief } from "src/shared/interface/brief";

interface Props {
  briefContent: Brief;
}

const BcPdf = ({ briefContent}: Props) => {
  const logo = "https://assets-pdf-edc.s3.amazonaws.com/logo_png.png";
  const portada = "https://assets-pdf-edc.s3.amazonaws.com/portada.png";
  return (
    <Document>
      <Page size="LETTER" style={styles.body}>
        <View style={styles.headerPage}>
          <Image style={styles.image} src={logo} />
          <View style={styles.headerData}>
            <View>
              <Text
                style={[
                  styles.dataStatus,
                  {
                    color:
                      briefContent.status === "COMPLETE"
                        ? "#33691E"
                        : "#FFFDE7",
                  },
                ]}
              >
                Estado:{" "}
                {briefContent.status === "COMPLETE"
                  ? "Completado"
                  : "En Proceso"}
              </Text>
              <Text style={styles.dataOptions}>Id: {briefContent.id}</Text>
              <Text style={styles.dataOptions}>
                Tipo de Brief: {briefContent.briefType}
              </Text>
              <Text style={styles.dataOptions}>
                Nombre: {briefContent.name}
              </Text>
              <Text style={styles.dataOptions}>
                Creación: {briefContent.dateCreate}
              </Text>
              <Text style={styles.dataOptions}>
                Modificación: {briefContent.dateEdit}
              </Text>
              <Text style={styles.dataOptions}>
                Generado: {new Date().toLocaleString("es-ES", optionsTime as any)}
              </Text>
              <Text style={styles.dataOptions}>
                Usuario: {briefContent.user}
              </Text>
              <Text style={styles.dataOptions}>
                Versión: {briefContent.version}
              </Text>
            </View>
          </View>
        </View>

        <Image style={styles.portada} src={portada} />
        {briefContent.fields.pertenece_estrategia && (
          <>
            <Text style={styles.bold}>
              {" "}
              ¿Pertenece a alguna estrategia de la pirámide?
            </Text>
            <Text style={styles.text}>
              {briefContent.fields.pertenece_estrategia}
            </Text>
          </>
        )}
        {briefContent.fields.descripcion && (
          <>
            <Text style={styles.bold}>Describe tu requerimiento:</Text>
            <Text style={styles.text}>{briefContent.fields.descripcion}</Text>
          </>
        )}
        {briefContent.fields.fecha_salida && (
          <>
            <Text style={styles.bold}>Fecha de salida:</Text>
            <Text style={styles.text}>{briefContent.fields.fecha_salida}</Text>
          </>
        )}
        {briefContent.fields.fecha_entrega && (
          <>
            <Text style={styles.bold}>Fecha de estimada de entrega:</Text>
            <Text style={styles.text}>{briefContent.fields.fecha_entrega}</Text>
          </>
        )}
        <Text style={styles.bold}>¿A qué nivel pertenece la campaña?</Text>
        <Text style={styles.text}>{briefContent.fields.nivel}</Text>
        <Text style={styles.bold}>¿Cuál es el nombre de la campaña?</Text>
        <Text style={styles.text}>{briefContent.fields.name}</Text>

        <Text style={styles.bold}>Indica nomenclatura para facturación:</Text>
        <Text style={styles.text}>{briefContent.fields.nomenclatura}</Text>
        <Text style={styles.bold}>¿A qué marca pertenece la campaña?</Text>
        <Text style={styles.text}>{briefContent.fields.marca.join(", ")}</Text>
        <Text style={styles.bold}>
          ¿A que ciclo de vida de mercadeo pertenece la campaña?
        </Text>
        <Text style={styles.text}>{briefContent.fields.ciclo.join(", ")}</Text>
        <Text style={styles.bold}>¿Cuándo inicia la campaña?</Text>
        <Text style={styles.text}>{briefContent.fields.fecha_inicio}</Text>
        <Text style={styles.bold}>¿Cuándo termina la campaña?</Text>
        <Text style={styles.text}>{briefContent.fields.fecha_fin}</Text>
        {/* ----------------- */}

        <Text style={styles.titleObjetivos}>Objetivo de mercadeo:</Text>

        {briefContent.fields.objetivo.map(
          (objetivo: any, index: number) => (
            <View style={styles.viewObjetivos} key={`Objetivo${index}`}>
              <Text style={styles.bold}>
                Objetivo: <Text style={styles.text}>{objetivo.objetivo}</Text>
              </Text>
            </View>
          )
        )}
        <Text style={styles.bold}>KRs:</Text>
        <Text style={styles.text}>{briefContent.fields.krs}</Text>
        <Text style={styles.bold}>Estrategia macro: </Text>
        <Text style={styles.text}>{briefContent.fields.estrategia_macro}</Text>
        <Text style={styles.bold}>
          ¿A quién le vamos a hablar con esta campaña? Market place
          (adressable):
        </Text>
        <Text style={styles.text}>{briefContent.fields.adressable}</Text>
        <Text style={styles.bold}>
          ¿A quién le vamos a hablar con esta campaña? Perfil de la audiencia /
          Buyer Persona
        </Text>
        <Text style={styles.text}>{briefContent.fields.audiencia}</Text>
        <Text style={styles.bold}>
          ¿Cuál es el atributo de marca asociado a esta campaña?{" "}
        </Text>
        <Text style={styles.text}>{briefContent.fields.seasonality_mode.join(", ")}</Text>

        <Text style={styles.bold}>
          ¿Qué espera que la audiencia piense, haga o sienta después de estar
          expuesta / tener contacto con esta comunicación?{" "}
        </Text>
        <Text style={styles.text}>{briefContent.fields.audiencia_piensa}</Text>

        <Text style={styles.bold}>
          ¿Por qué hoy esto no pasa? ¿Qué impide a nuestra audiencia hacer,
          pensar o sentir esto?{" "}
        </Text>
        <Text style={styles.text}>{briefContent.fields.hoy_no}</Text>

        <Text style={styles.bold}>
          ¿Qué tenemos para ofrecer que los motive a hacer lo que queremos que
          hagan, piense o sienta? (diferencial, beneficio, RTB){" "}
        </Text>
        <Text style={styles.text}>{briefContent.fields.que_tenemos}</Text>

        <Text style={styles.bold}>
          ¿Existe algún competidor local y/o global que esté ofreciendo lo mismo
          o un producto sustituto y en su criterio lo esté haciendo bien? ¿Cuál?
          ¿Qué está haciendo? ¿por qué lo está haciendo bien?{" "}
        </Text>
        <Text style={styles.text}>{briefContent.fields.competidor_local}</Text>

        {/* ----------------- */}

        <Text style={styles.titleObjetivos}>Objetivos de medios</Text>

        {briefContent.fields.objetivos_medios.map(
          (objetivo: any, index: number) => (
            <View style={styles.viewObjetivos} key={`Objetivo${index}`}>
              <Text style={styles.bold}>
                Tipo de objetivo:{" "}
                <Text style={styles.text}>{objetivo.type}</Text>
              </Text>
              <Text style={styles.bold}>
                Etapa: <Text style={styles.text}>{objetivo.etapa}</Text>
              </Text>
              <Text style={styles.bold}>
                Objetivos: <Text style={styles.text}>{objetivo.objetivos}</Text>
              </Text>
            </View>
          )
        )}
        <Text style={styles.bold}>Presupuesto medios:</Text>
        <Text style={styles.text}>
          {briefContent.fields.presupuesto_medios}
        </Text>
        <Text style={styles.bold}>Presupuesto producciones:</Text>
        <Text style={styles.text}>
          {briefContent.fields.presupuesto_producciones}
        </Text>
        <Text style={styles.bold}>¿A que MDO se carga el ppto?</Text>
        <Text style={styles.text}>{briefContent.fields.presupuesto_owner}</Text>
        <Text style={styles.bold}>
          ¿Qué equipos (internos y externos) van a participar en este proceso?
          ¿Cuál es el rol de cada uno?
        </Text>
        <Text style={styles.text}>{briefContent.fields.equipo}</Text>
        <Text style={styles.bold}>
          ¿Para que países se requiren los derechos para utilizar las piezas de
          la campaña?
        </Text>
        <Text style={styles.text}>{briefContent.fields.paises.join(", ")}</Text>
        <Text style={styles.bold}>
          ¿Por cuánto tiempo se utilizarán las piezas de la campaña?
        </Text>
        <Text style={styles.text}>{briefContent.fields.tiempo}</Text>
        <Text style={styles.bold}>Pre-read de negocio y producto:</Text>
        <Link style={styles.link} src={briefContent.fields.preread}>
          {" "}
          Descargar Archivo.
        </Link>
        <Text style={styles.bold}>One page:</Text>
        <Link style={styles.link} src={briefContent.fields.onepage}>
          {" "}
          Descargar Archivo.
        </Link>
      </Page>
    </Document>
  );
};

Font.register({
  family: "Open Sans",
  src: "https://fonts.gstatic.com/s/opensans/v29/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4jaVQUwaEQbjB_mQ.woff",
});

Font.register({
  family: "CIBFontSans Bold",
  src: "https://library-sdb.apps.bancolombia.com/fenix/0.0.1/assets/fonts/CIBFont/CIBFontSans-Bold.ttf",
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: "right",
    fontFamily: "CIBFontSans Bold",
  },
  titleObjetivos: {
    marginTop: 10,
    fontSize: 18,
    textAlign: "left",
    fontFamily: "CIBFontSans Bold",
    marginBottom: 10,
  },
  viewObjetivos: {
    marginTop: 5,
    border: "1px solid #E0E0E0",
    borderRadius: 8,
    textAlign: "left",
    marginBottom: 5,
    padding: 5,
  },
  author: {
    fontSize: 12,
    textAlign: "right",
  },
  dataOptions: {
    fontSize: 8,
    textAlign: "right",
  },
  dataStatus: {
    margin: "5px 0",
    fontFamily: "CIBFontSans Bold",
    fontSize: 10,
    textAlign: "right",
  },
  headerData: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  email: {
    fontSize: 12,
    textAlign: "right",
    marginBottom: 40,
  },
  hr: {
    marginTop: 40,
    textAlign: "left",
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: "Open Sans",
  },
  text: {
    margin: 6,
    fontSize: 12,
    textAlign: "left",
    fontFamily: "Open Sans",
  },
  link: {
    margin: 6,
    fontSize: 12,
    textAlign: "left",
    fontFamily: "Open Sans",
  },
  bold: {
    margin: 0,
    fontSize: 12,
    textAlign: "left",
    fontFamily: "CIBFontSans Bold",
  },
  image: {
    width: 100,
    height: 13,
    marginVertical: 5,
    marginHorizontal: 5,
  },
  qr: {
    width: 100,
    marginVertical: 5,
    marginHorizontal: 5,
  },
  portada: {
    marginVertical: 5,
    marginHorizontal: 5,
    marginBottom: 40,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
  },
  headerPage: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
});

export default BcPdf;
